import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import WebCamModal from './WebCamModal';
import { useDispatch, useSelector } from 'react-redux';
import { BzChip, BzButton, BzModal, BzModalBody, BzModalHeader } from '../../components';
import { handleModal } from '../../redux/actions/modals';
import config from '../../config.json';
import { updateUserPreference, uploadUserProfilePicture } from '../../redux/actions/header';
import { APP_INFO_PARAMS, EXCHANGE_NAME_NOTIFICATION, LINK_OPEN_MODES, NetNetPGQSMode, VOLUNTARY_BLOCK_TITLE } from '../../utils/global_variables';
import { getUserProfile } from '../../redux/actions/auth';
import { EncodeToBase64, getAppInfoData, getDyanmicURL, isGuestUser, maskNumber } from '../../utils/global_functions';
import ProfileConfirmationModal from './ProfileConfirmationModal';
import { _getInitialsFromUserName } from '../../controllers';
import { toastConfig } from '../../redux/actions/toast';
import ConfirmationBoxModal from './ConfirmationBoxModal';
import { updateInAppIFrame } from '../../redux/actions/appInfo';
import { useNavigate } from 'react-router';

const strBankMask = '********';

const ProfileModal = ({ currentPreference }) => {
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const iframeURL = queryParams.get('iframeURL');
    const dispatch = useDispatch();
    const profilePictureRef = useRef();

    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const userProfile = useSelector(state => state.auth.userProfile);
    const userPreference = useSelector(state => state.notification.userPreference);
    const appInfo = useSelector(state => state.appInfo.appInfo);

    const [isEditProfilePicture, setIsEditProfilePicture] = useState(false);
    const [isEditUserInfo, setIsEditUserInfo] = useState(false);
    const [showDpDetails, setShowDpDetails] = useState('');


    const canUpdateProfile = useMemo(() => {
        return !getAppInfoData(APP_INFO_PARAMS.APP_HIDE_PROFILE_UPDATE);
    }, [appInfo]);

    const howItWorks = useMemo(() => {
        return getAppInfoData(APP_INFO_PARAMS.APP_PROFILE_UPDATE_CONTENT);
    }, [appInfo]);

    const viewMore = useMemo(() => {
        return getAppInfoData(APP_INFO_PARAMS.APP_DOWNLOAD_KYC_URL);
    }, [appInfo]);

    // Deepti B.[30/09/2024]: BT-144474: If the key is ON, system shall display the link for voluntary access block in Breeze as well as the report in Web admin.
    const voluntaryAccess = useMemo(() => {
        return getAppInfoData(APP_INFO_PARAMS.APP_VOLUNTARY_BLOCKING);
    }, [appInfo])

    useEffect(() => {
        if (!isGuestUser()) {
            if (!Object.keys(userProfile)?.length) {
                dispatch(getUserProfile());
            }
            else { }
        } else { }

    }, [dispatch]);

    useEffect(() => {
        setIsEditProfilePicture(false);
    }, [userPreference]);

    const onHide = () => {
        dispatch(handleModal([{ "USER_PROFILE_MODAL": false }]));
        setIsEditUserInfo(false);
        setIsEditProfilePicture(false);
    };

    const handleEditProfilePicture = () => {
        setIsEditProfilePicture(true);
    };


    const handleRemoveProfilePicture = () => {
        if (currentPreference?.sProfilePicPath) {
            dispatch(handleModal([{ 'PROFILE_CONFIRMATION_MODAL': true }]));
        }
        else { }
    };

    const onSubmitRemoveProfilePicture = () => {
        const preferencePayload = {
            sProfilePicPath: "",
        };
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
        dispatch(updateUserPreference(currentPreference, preferencePayload));
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End
        dispatch(handleModal([{ 'PROFILE_CONFIRMATION_MODAL': false }]));
        profilePictureRef.current.value = '';

    };
    const handleViewClick = () => {
        dispatch(toastConfig({}));
    };
    const onSubmitProfilePicture = (file) => {

        const fileName = new Date().getTime() + '.jpeg';
        const formData = new FormData();
        if (file) {
            formData.append('file', file, fileName);
            formData.append('tenantId', config.TenantId);
            formData.append('userId', objLoginSession?.data?.user_id);
            dispatch(uploadUserProfilePicture({ formData, currentPreference })).then((res) => {
                if (res?.objRes1?.status && res?.objRes2) {
                     dispatch(toastConfig({
                        autoDismiss: true, show: true, message: `Profile Picture update successfully.`
                    }));
                } else {
                    dispatch(toastConfig({
                        autoDismiss: false, show: true, btnName: "Ok", className: 'btn  btn-solid ms-3', button: [{
                            btnName: "Ok", className: 'btn  btn-solid ms-3', onClickHandler: () => { handleViewClick(); }
                        }], message: `Ooop!! Unable to upload Please try again...`
                    }));
                }
            });
        }
        // else {
        //     const preferencePayload = {
        //         "sProfilePicPath": null,
        //     };
        //     dispatch(updateUserPreference(currentPreference, preferencePayload));
        // }
    };

// Deepti B.: BT-14474: open voluntary access url

const createPGURL = (param, url,type="") => {
    let arr = url.split('?');
    let sURL = arr[0];
    let sQSParam;
    if(NetNetPGQSMode == 1) {
      if(param) {
        sQSParam = arr[1] + "&" + param;
      } else {
        sQSParam = arr[1];
      }
      let sEncQParam = "enct=" + EncodeToBase64(sQSParam);
      let sPGURL = "";
      if (type) {
        sPGURL = sURL + "?" + sEncQParam + `&${type}=` + NetNetPGQSMode;
      } else {
        sPGURL = sURL + "?" + sEncQParam + "&Mode=" + NetNetPGQSMode;
      }
      return sPGURL;
    }
}

const handleBlockAccess = () => {
    dispatch(handleModal([{"CONFIRMATION_MODAL": false}]));
    let blockTitle = VOLUNTARY_BLOCK_TITLE;
    if (voluntaryAccess?.voluntaryblockingurl) {
        let url = voluntaryAccess?.voluntaryblockingurl || '';
        // Deepti B. BT-144474 added new argument isVoluntaryBlock passed as true to indicate function 'getDyanmicURL' is being called for voluntary blocking functionality.
        let blockingUrl = getDyanmicURL({url}, objLoginSession, true, true);
        // Deepti B: if user has not configured their own url then url params will be encrypted
        if (!voluntaryAccess?.isthirdpartyurl) {
            blockingUrl = createPGURL('', blockingUrl, 'type');
        }
        if (voluntaryAccess?.openmode === LINK_OPEN_MODES.IFRAME) {
            navigate(`?iframeURL=${blockingUrl}`)
            dispatch(updateInAppIFrame({ url: blockingUrl, title: blockTitle }));
            dispatch(handleModal([{ "IN_APP_IFRAME": true }]));
        }
        else {
            window.open(blockingUrl);
        }
    }
}

    const handleDrop = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        onSubmitProfilePicture(file);
    };

    const handleDragOver = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const handleShowDpDetails = (id) => {
        setShowDpDetails(curr => curr === id ? '' : id);
    };

    //TODO:Do not remove code - To be implemented after webcam issue is resolve
    const handleOpenCamera = () => {
        dispatch(handleModal([{ 'PROFILE_WEB_CAM_MODAL': true }]));
    };


    /*SAT_BT-109047_Breeze-User Profile  --start */
    const closeAccount = () => {
        dispatch(handleModal([{ "CLOSE_ACCOUNT_MODAL": true }]));
    };
    /*SAT_BT-109047_Breeze-User Profile --end */

    // Deepti B: BT-144474: Voluntary block online access confirmation modal
    const blockOnlineAccess = () => {
        dispatch(handleModal([{ "CONFIRMATION_MODAL": true }]));
    }

    //Ameersha N --- handle Img broken Logic for profile picture --Start
    const [brokenImg, setIsImageBroken] = useState(false);

    const isImageBroken = useMemo(() => {
        return brokenImg;
    }, [brokenImg]);

    const handleImageError = useCallback(() => {
        setIsImageBroken(true);
    }, []);

    const handleImageLoad = useCallback(() => {
        setIsImageBroken(false);
    }, []);

    useEffect(() => {
        return () => {
            setIsImageBroken(false);
        };
    }, []);
    //Ameersha N --- handle Img broken Logic for profile picture --End

    return (<>
        <BzModal size={isEditProfilePicture ? '' : 'lg'} show={modals['USER_PROFILE_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true" centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div data-testid='profile_modal_heading' className='font-medium font-size5 color-text'>{isEditProfilePicture ? 'Profile Picture Setting' : isEditUserInfo ? 'User Information' : 'Profile'}</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div data-testid='profile_modal_close' className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                {isEditProfilePicture
                    ?
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col>
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-center align-content-center'>
                                        <div className='avatar-wrap'>
                                            <div className='profile-picture-settings' onDragOver={handleDragOver} onDrop={handleDrop}>
                                                {currentPreference?.sProfilePicPath && !isImageBroken ? <img height={150} width={150} style={{ borderRadius: '50%' }} src={currentPreference?.sProfilePicPath} alt={objLoginSession?.data?.user_name} onLoad={handleImageLoad} onError={handleImageError} />
                                                    : <> <div className='profile-picture-name'>{_getInitialsFromUserName(objLoginSession?.data?.user_name)?.data}</div> {/* { Shuaib P - 22-11-2023-BT-109047_Breeze-User Profile } */}
                                                        <div className='profile-picture-discription'>Set profile picture</div>
                                                    </>}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='g-0 my-3'>
                                    <Col md={8} className='mrgauto'>
                                        <Row className='g-0 mb-3'>
                                            <Col>
                                                <input type='file' hidden onChange={(e) => onSubmitProfilePicture(e.target.files[0])} id='profilePicture' ref={profilePictureRef} />
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col className='me-1' onClick={() => handleOpenCamera()}>
                                                <label className='btn btn-md btn-primary btn-block mb-2'>
                                                    <span>Camera</span>
                                                </label>
                                            </Col>
                                            <Col className='ms-1' onClick={() => onSubmitProfilePicture()}>
                                                <label htmlFor='profilePicture' className='btn btn-md btn-primary btn-block mb-2'>
                                                    <span htmlFor='profilePicture'>Gallery</span>
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mt-3'>
                                            <Col className='d-flex justify-content-center align-items-center mrgauto'>
                                                <BzButton className='btn btn-md btn-outline' onClick={handleRemoveProfilePicture}>Remove Profile Picture</BzButton>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                    :
                    isEditUserInfo ?
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col>
                                    <Row className='g-0 mb-2'>
                                        <Col>
                                            <div className='font-medium font-size4 color-text'>Update your Details</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-2'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text mb-1'>{howItWorks?.updateProfile}</div>
                                            <ul>
                                                {howItWorks?.contentList?.map((content, i) =>
                                                    <li key={i} className='font-regular font-size2 color-text'>{content}</li>
                                                )}
                                            </ul>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-3'>
                                        <Col md={4} className='d-flex justify-content-center mrgauto'>
                                            <a variant='link' href={viewMore} target='_blank' className='btn btn-md btn-block btn-primary cursor-pointer'>Click Here</a>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                        :
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col>
                                    <Row className='g-0'>
                                        <Col md='auto' className='d-flex justify-content-start' onClick={handleEditProfilePicture}>
                                            <div className='profile-wrap'>
                                                <div className='profile-edits'>
                                                    {currentPreference?.sProfilePicPath && !isImageBroken ? <img height={80} width={80} className='my-1' style={{ borderRadius: '50%' }} src={currentPreference?.sProfilePicPath} alt={_getInitialsFromUserName(objLoginSession?.data?.user_name)?.data} onLoad={handleImageLoad} onError={handleImageError} /> : <div className='profile-name'>{_getInitialsFromUserName(objLoginSession?.data?.user_name)?.data}</div>}
                                                </div>
                                                <div className='edit-wrap'>
                                                    <div data-testid='edit-profile-pic' className='icon-12 icon-edit icon-dark'></div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={9} className='d-flex flex-column justify-content-center ms-2'>
                                            <div className='font-medium font-size4 color-text'>
                                                {objLoginSession?.data?.user_name}
                                            </div>
                                            <div className='font-regular font-size2 color-subtext'>
                                                USER ID : {objLoginSession?.data?.alias_id ? objLoginSession?.data?.alias_id : objLoginSession?.data?.user_id}
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className='bdr-btm-secondary'>&nbsp;</div>
                                    <Row className='g-0 mt-3'>
                                        <Col>
                                            <div className='font-medium font-size4 color-text'>User Information</div>
                                        </Col>
                                        {canUpdateProfile && <Col className='d-flex justify-content-end align-items-center'>
                                            <div className='icon-14 icon-edit icon-dark me-2' onClick={() => { setIsEditUserInfo(true); }}></div>
                                            <div className='font-medium font-size4 color-text'>Update</div>
                                        </Col>}
                                    </Row>
                                    <Row className='g-0 mt-3'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>Phone</div>
                                        </Col>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>{userProfile?.mobile_no}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-3'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>Email</div>
                                        </Col>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>{userProfile?.email}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-3'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>Pan No.</div>
                                        </Col>
                                        <Col>
                                            {/* Removed masking of PAN number as per changes to profile api */}
                                            <div className='font-regular font-size3 color-text'>{userProfile?.pan}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-3'>
                                        <Col>
                                            <div className='font-regular font-size3 color-text'>Segments Allowed</div>
                                        </Col>
                                        <Col>
                                            <div className='chips-wrap'>
                                                {objLoginSession?.data?.exchanges?.map((exchange, i) => exchange ?
                                                    <BzChip className='chips info-chip me-2 mb-2' key={i}>{EXCHANGE_NAME_NOTIFICATION[exchange]}</BzChip>
                                                    : null
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className='bdr-btm-secondary'>&nbsp;</div>
                                    {
                                        userProfile?.bank_details?.length ? <Row className='g-0 mt-3'>
                                            <Col>
                                                <div className='font-medium font-size5 color-text'>Bank Account</div>
                                            </Col>
                                            <Col>
                                                {
                                                    userProfile?.bank_details?.length ? userProfile?.bank_details?.map((bank, i) =>
                                                        <Row key={i} className='g-0 py-2 align-items-center'>
                                                            <Col className='d-flex justify-content-start'>
                                                                <div className='font-medium font-size4 color-text text-capitalize'>{bank?.bank_name}</div>
                                                            </Col>
                                                            <Col className='d-flex justify-content-end'>
                                                                <div className='font-regular font-size4 color-text'>{maskNumber(bank?.account_no, strBankMask)}</div>
                                                            </Col>
                                                        </Row>
                                                    )
                                                        : null
                                                }
                                            </Col>
                                        </Row> : null
                                    }
                                    {
                                        userProfile?.dp_details?.length ?
                                            <Row className='g-0 mt-3'>
                                                <Col>
                                                    <div className='font-medium font-size5 color-text'>Demat Information</div>
                                                </Col>
                                                <Col>
                                                    {userProfile?.dp_details?.map((dp, i) =>
                                                        <div className='bdr-btm cursor-pointer' key={i}>
                                                            <Row className='g-0 d-flex justify-content-start align-items-start py-2' onClick={() => handleShowDpDetails(dp?.dpId)}>
                                                                <Col md={10} className='d-flex flex-column'>
                                                                    <div className='font-medium font-size4 color-text pb-1'>{dp?.dpName}</div>
                                                                    <div className='font-regular font-size2 color-subtext'>{dp?.dpType}</div>
                                                                </Col>
                                                                <Col md={2} className='d-flex justify-content-end'>
                                                                    <div className={`icon-14 icon-${showDpDetails === dp?.dpId ? 'arrowdown' : 'arrowright'} icon-dark mt-2`} onClick={() => handleShowDpDetails(dp?.dpId)}></div>
                                                                </Col>
                                                            </Row>
                                                            {showDpDetails === dp?.dpId ?
                                                                <>
                                                                    <Row className='g-0 align-items-center'>
                                                                        <Col className='d-flex justify-content-start'>
                                                                            <div className='font-regular font-size2 color-subtext'>DP ID</div>
                                                                        </Col>
                                                                        <Col className='d-flex justify-content-end'>
                                                                            <div className='font-medium font-size2 color-text'>{dp?.dpId}</div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='g-0 align-items-center pb-2'>
                                                                        <Col className='d-flex justify-content-start'>
                                                                            <div className='font-regular font-size2 color-subtext'>Beneficiary ID</div>
                                                                        </Col>
                                                                        <Col className='d-flex justify-content-end'>
                                                                            <div className='font-medium font-size2 color-text'>{dp?.clientBeneficiaryId}</div>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                                : null}
                                                        </div>
                                                    )
                                                    }
                                                </Col>
                                            </Row> : null
                                    }
                                    <Row className='g-0 mt-3 justify-content-start'>
                                        <Col>
                                            <BzButton data-testid='close_accnt_btn' className='btn btn-md btn-outline' onClick={closeAccount}>Close Account</BzButton>
                                        </Col>
                                        {voluntaryAccess.voluntaryblockingonoff === "ON" && (
                                            <Col>
                                                <BzButton className='btn btn-md btn-outline' onClick={blockOnlineAccess}>{VOLUNTARY_BLOCK_TITLE}</BzButton>
                                            </Col>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                }
            </BzModalBody>
        </BzModal>
        <ProfileConfirmationModal onSubmitRemoveProfilePicture={onSubmitRemoveProfilePicture} />
        <WebCamModal onSubmitProfilePicture={onSubmitProfilePicture} />
        <ConfirmationBoxModal header={VOLUNTARY_BLOCK_TITLE} bodyMsg={"Do you want to Block Online Access?"} handleConfirmed={handleBlockAccess} />
    </>
    );
};

export default memo(ProfileModal)

